/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-nested-ternary,camelcase */
import BasePresenter from '@src/js/separate-logic/base-presenter';
import { transaction } from '@src/slide/domain/slide-app';
import _has from 'lodash/has';
import * as mobx from 'mobx';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { TEXT_CHANGE } from '@src/js/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { external } from '@src/js/separate-logic/decorate/external';
import _get from 'lodash/get';
import { PlaceHolderMode } from '@src/slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import { getTextRect } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/text-rect';
import TextAdjustManager from '@src/slide/domain/ui-model/element-modeles/property/text/text-adjust';
import { AutoFitType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { updateFontScale } from '@src/slide/domain/ui-model/element-modeles/property/text/text-adjust/font-scale-adjust';
import { isVerticalDirection, getLogicPropertyKeyMap } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/text-direction';
import isEqual from 'lodash/isEqual';
import { enumerateGroup } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import { ITextEditorStateService } from '@src/slide/application/service/text-editor-state-service/text-editor-state-service.interface';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { isDecoratorKey } from '@src/slide/infrastructure/module/independent/keyboard/decorator';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { MenuManagerEventsKeys } from '@src/slide/application/service/menu-manager/menu-manager-events.interface';
import {
    ModelMenuRefreshEventsKeys,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-menu-refresh.interface';

export default class ShapeElementPresenter extends BasePresenter {
    private mounted: boolean;
    private autoFocus: boolean; // 移动端IOS无法自动获取焦点，但会改变editing状态
    private isEditing: boolean;
    private selectElementChangeReaction;
    private savedStr: string;
    private size: any;
    private isSelecedWhenTouchStart: boolean;
    private borderMouseDown: boolean;
    private editorHeight;
    public init(props: any) {
        this.mounted = false;
        this.autoFocus = !browser.isMobile;
        this.size = {
            width: props.component?.props.style.width,
            height: props.component?.props.style.height,
        };
    }

    public componentDidMount() {
        this.mounted = true;
        if (!this.props.fromScale) {
            this.updateElementFocus();
        }

        this.disposeOnUnmount(mobx.reaction(() => ({
            selected: this.component?.selected,
        }), (obj) => {
            if (obj.selected) {
                // 聚焦
                this.handleElementFocus();
            } else {
                // 失焦
                this.handleElementBlur();
            }
        }));
        this.disposeOnUnmount(mobx.reaction(
            () => this.getEditingStateManager().isResizing,
            (isResizing) => {
                if (!isResizing) {
                    this.model.setResize = true;
                }
            },
        ));
        // // 处理恢复空占位符编辑态的事件监听
        // SlideApp.event.on('recover-placeholder-edit', this.handleEnterEmptyPlaceholder);
    }

    public componentWillReceiveProps(nextProps) {
        const { width, height, controlValues } = nextProps.component.props.style;

        if (this.size.width !== width || this.size.height !== height) {
            this.size.width = width;
            this.size.height = height;
            this.model.setResize = true;
        }

        const nextControlValues = controlValues?.length > 0 ? controlValues
            : this.component.pathParser.getDefaultControlValues();
        if (!isEqual(nextControlValues, this.component.pathParser.controlValues)) {
            this.component.pathParser.updateControlValues(nextControlValues);
            this.model.setResize = true;
        }

        if (nextProps.component.undoRedo) {
            this.model.setResize = true;
        }
    }
    public componentWillUpdate(nextProps, nextModel) {
        // eslint-disable-next-line no-param-reassign
    }
    public componentDidUpdate() {
        if (!this.props.fromScale) {
            if (this.component) {
                this.component.editorComponent = this.getChildRef('editor');
                if (this.component.editorEnterFocus && this.autoFocus) {
                    this.component.editorEnterFocus = false;
                    this.model.editorFocus = true;
                    setTimeout(() => this.getChildRef('editor')?.setFocus(), 0); // 某些情况下循环渲染场景会造成blur，推迟进行focus
                }
                // 此方法本应该在ShapeModel的didConvertDataSdkToUi中调用，但是内部需要从editor取值，所以只能先放在这里了
                this.component.getMenuManager()?.event.emit(ModelMenuRefreshEventsKeys.REFRESH_MENU_ITEM_VALUES);
                this.component.getMenuManager()?.event.emit(ModelMenuRefreshEventsKeys.REFRESH_GROUP_ITEM_VALUES);
            }
            this.props.onElementUpdate?.();
        }
        const { width, height, controlValues, bgShape } = this.component.props.style;
        this.component.pathParser.update({
            type: bgShape,
            controlValues,
            width,
            height,
        });
    }
    public componentWillUnmount() {
        this.mounted = false;
        if (this.isEditing) {
            const model = this.component;
            if (model?.soruceRefForUI?.childUiModelFromId(model.id)) { // 如果元素被删除不会进入逻辑
                this.handleElementBlur();
            }
        }
        this.selectElementChangeReaction?.();
        // // 移除恢复空占位符编辑态的事件监听
        // SlideApp.event.off('recover-placeholder-edit', this.handleEnterEmptyPlaceholder);
    }

    @dispatchProps()
    public handleClick = (e) => {
        // 如果这里能拿到click事件，说明点击点不在文字区域，需要触发editor的blur
        // 移动端，当选中后，单击获取焦点
        if (browser.isMobile && this.isSelecedWhenTouchStart && !this.isEditing && !this.borderMouseDown) {
            this.handleDblClick(e);
            this.borderMouseDown = false;
            this.isSelecedWhenTouchStart = false;
            return;
        }
        this.borderMouseDown = false;
        this.isSelecedWhenTouchStart = false;

        this.getChildRef('editor')?.triggerBlur({ needUpd8: this.props.editable });
        if (this.model.isPlaceHolder && !browser.isMobile) return;
        this.setModel({
            editorFocus: false,
            mobileEditingTriggerFlag: false,
        });
        this.isEditing = false;

        this.handleShapeLinkFlagClick();
    };
    @dispatchProps()
    public handleDblClick = (e) => {
        // FIXME 可能会对外层的事件造成影响，需要在做事件处理的时候判断
        if (this.props.editable) {
            e?.stopPropagation();

            this.enterEditor(e);
        }
        this.showNotEditTips(() => {
            e?.stopPropagation();
        });
        // e && e.stopPropagation();
    };
    @dispatchProps()
    public handleElementTouchStart = () => {
        this.isSelecedWhenTouchStart = this.component?.selected;
    };

    // ================ 文本区域回调 ================
    @dispatchProps()
    public handleEditorMouseDown = (e) => {
        if (this.props.editorMouseDown) {
            this.props.editorMouseDown();
        }
        if (this.isEditing) { // 如果文本框本身有焦点，不再处理以下逻辑
            return;
        }
        if (this.isEditing === false) {
            this.reportAfterEnterTextEditor();
        }
        if (!browser.isMobile) {
            this.isEditing = true;
        }
        this.makeElementSelected(e);
        // 移动端交互是点击文本框进入编辑，所以这里如果是只读，处理成选中状态下，再次点击弹出tips提示
        if (browser.isMobile && this.component?.selected) {
            this.showNotEditTips();
        }
    };
    @dispatchProps()
    public handleChange = (textBodyInfo) => {
        transaction(() => {
            const { paragraphList, textBodyStyle, height, width } = textBodyInfo;

            updateFontScale(this.component, { textBodyStyle, paragraphList });
            this.component?.updateParagraphList(paragraphList, textBodyStyle);

            if (textBodyStyle?.autoFitType === AutoFitType.SHAPE_AUTO_FIT) {
                const textDirection = textBodyStyle?.wrapperStyle?.textDirection;
                const { displayInlineSize, displayBlockSize } = this.getDisplayStyle(height, width, textDirection);
                TextAdjustManager.getInstance().updateShapeStyle(this.component, displayBlockSize, displayInlineSize);
            }
        });
    };

    @dispatchProps()
    public handleEditorStyleChange = ({ style } = { style: undefined }) => {
        if (!this.props.fromScale && this.component) {
            this.component.selectionStyles = style;
        }
    };
    @dispatchProps()
    public handlePlaceHolderClick = (type, e) => {
        switch (type) {
            // icon点击时需要取消别的shape的选中态
            case PlaceHolderMode.PIC:
            case PlaceHolderMode.TBL:
                this.getSelectionService()?.selectedElements.clear();
                this.makeElementSelected(e);
                break;
            case PlaceHolderMode.TXT:
            case PlaceHolderMode.BLANK:
                this.enterEditor(e, 'placeholder');
                break;
        }
    };

    /**
     * editor发生文字变化时，通知外层
     */
    @dispatchProps()
    public handleEditorContentChange = () => {
        this.getTextEditorStateService().editorContentChangeFlag += 1;
    };

    @dispatchProps()
    public handleEditorOperation = () => {
        requestAnimationFrame(() => {  // 下次render触发，保证修改已经生效。
            const h = this.getChildRef('editor')?.getTextAreaHeightSync();
            if ((h || this.editorHeight) && h !== this.editorHeight) {
                this.editorHeight = h;
                window.dispatchEvent(new Event('PPT-resize'));
            }
        });
    };
    @dispatchProps()
    public openMobileEditMode = (callback) => {
        this.setModel({
            mobileEditingTriggerFlag: true,
        }, () => {
            callback?.();
        });
    };
    // placeholder中类型的不可以变更level
    @dispatchProps()
    public getLevelChangeLock = () => {
        if (!this.model.isPlaceHolder) return false;
        const type = this.component?.placeHolder?.type;
        return type === PlaceHolderMode.TITLE || type === PlaceHolderMode.CTRTITLE;
    };

    // 处理Slate Editor退出编辑之后的回调
    @dispatchProps()
    public handleExitEditing = () => {
        if (browser.isMobile) {
            this.getTextEditorStateService().isSlateEditing = false;
            window?.log?.info('handleExitEditing scroll screen');
        }
        // 失去焦点后，修改状态
        this.isEditing = false;
        if (this.shouldChangeEditorFocus()) {
            // 如果手动triggerBlur，这里延迟修改是为了先存储数据，因为现在editor输入不会触发保存文字
            Promise.resolve().then(() => this.setModel({ editorFocus: false }));
        }
        // PC端无障碍也会使用
        window.dispatchEvent(new Event('exitEditing'));
        this.savedStr = '';
        // 失焦后，修改dataChanged强制重新cloneDom
        this.component.state.dataChanged = true;
    };
    @dispatchProps()
    public handleEnterEditing = () => {
        window?.log?.info('enter editing');
        this.getSearchReplaceManager()?.exitSearching();
        if (browser.isMobile) {
            this.getTextEditorStateService().isSlateEditing = true;
        }
        this.isEditing = true;
        // PC端无障碍也会使用
        window.dispatchEvent(new Event('enterEditing'));
        if (this.savedStr) {
            this.getChildRef('editor')?.insertTextEnd(this.savedStr);
            this.savedStr = '';
        }
    };
    @dispatchProps()
    public handleMouseEnter = () => {
        if (this.component?.selected) {
            this.getMenuManager()?.event.emit(MenuManagerEventsKeys.ENTER_ELEMENT, this.component.key);
        }
    };
    @dispatchProps()
    public handleMouseLeave = () => {
        if (this.component?.selected) {
            this.getMenuManager()?.event.emit(MenuManagerEventsKeys.LEAVE_ELEMENT, this.component.key);
        }
    };
    @dispatchProps()
    public getLinkData() {
        const componentProps = this.component?.props;
        if (isIframeShapeModel(this.component)) {
            return {
                href: {
                    url: componentProps.addon.originUrl,
                },
                addon: componentProps.addon,
            };
        }
        return componentProps.link;
    }
    @dispatchProps()
    public setResizeValue = (b) => {
        this.model.setResize = b;
    };
    @dispatchProps()
    public isSelected = component => (component.selected
        && this.getSelectionService()?.selectedElements.length === 1);

    @dispatchProps()
    public undoHandler = () => {
        this.getUndoRedoService()?.undo();
    };

    @dispatchProps()
    public redoHandler = () => {
        this.getUndoRedoService()?.redo();
    };

    @dispatchProps()
    public handleTextChange = ({ height, width, text }) => {
        if (this.component?.textBodyStyle?.autoFitType !== AutoFitType.SHAPE_AUTO_FIT) {
            return;
        }
        const textDirection = this.component?.textBodyStyle?.wrapperStyle?.textDirection;
        const { displayInlineSize, displayBlockSize } = this.getDisplayStyle(height, width, textDirection);
        TextAdjustManager.getInstance().updateShapeStyleForUI(this.component, displayBlockSize, displayInlineSize);

        window.dispatchEvent(new CustomEvent(TEXT_CHANGE, { detail: { text } }));
    };

    @dispatchProps()
    public onAttachmentFirstShow = () => {
        if (this.component) {
            this.component.isAttachmentShown = true;  // 触发列表对应元素刷新
            this.component.state.dataChanged = true;  // 触发clone dom更新
        }
    };

    @dispatchProps()
    public getMediaManager(): IMediaManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .viewableServiceLayer.mediaManager;
    }

    @dispatchProps()
    public getMenuManager(): IMenuManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .editableServiceLayer?.menuManager;
    }


    @external()
    public getCloneDom = () => {
        let backgroundContainer: any = null;
        // 母版中背景为空值，添加保护
        if (this.getChildRef('backgroundContainerRef')) {
            backgroundContainer = this.getChildRef('backgroundContainerRef').cloneNode(false);
            backgroundContainer.appendChild(this.getChildRef('backgroundContainerRef').getCloneDom());
        }
        return [
            backgroundContainer,
            this.getChildRef('editorWrapper').cloneNode(true),
        ];
    };

    private getDisplayStyle(height, width, textDirection?) {
        let inlineSize;
        let blockSize;
        const isVert = isVerticalDirection(textDirection);
        const logicKeys = getLogicPropertyKeyMap(textDirection);
        if (isVert) {
            inlineSize = height;
            blockSize = width;
        } else {
            inlineSize = width;
            blockSize = height;
        }

        const textRect = getTextRect(this.component, this.component.pathParser, this.component.props.style);
        const displayBlockSize = blockSize;
        let displayInlineSize;
        if (inlineSize) {
            displayInlineSize = TextAdjustManager.getInstance().
                getDisplayInlineSize(this.component, inlineSize, textRect, null, textDirection);
        } else {
            displayInlineSize = this.component.props.style[logicKeys.inlineSize];
        }
        return { displayInlineSize, displayBlockSize };
    }

    private get component() {
        return this.props.component;
    }
    private handleShapeLinkFlagClick = () => {
        if (this.component?.currentEditState !== PPTEditorStateType.EDITABLE) {
            const linkData = this.component?.props.link;
            // 在非编辑态为插件时点击不直接跳转链接
            if (_get(this.props, 'component.props.addon')) return;
            const data = linkData ? linkData.href : null;
            const href = data ? this.getLinkManager().getLinkUrlWithData(data) : undefined;
            if (href) {
                this.getMenuManager()?.event.emit(MenuManagerEventsKeys.LINK_CLICK, this.component?.key);
            }
        }
    };

    /**
     * 失去焦点后，检查是否需要手动更改editorFocus的状态
     */
    private shouldChangeEditorFocus() {
        return this.model.editorFocus && this.component.isPlaceholder && !this.getChildRef('editor')?.isNotChangeToLite();
    }

    // 如果shape.init_focus为true，默认设置焦点到text-editor上
    private initFocus = () => {
        if (this.component?.initFocus && !this.props.fromScale) {
            this.triggerFocus();
            if (this.component?.initFocus) {
                this.component.initFocus = false;
            }
        }
    };

    private triggerFocus = () => {
        if (this.props.editable) {
            this.enterEditor();
        }
        this.showNotEditTips();
    };

    private enterEditor = (e?: any, source?: string) => {
        if (this.isEditing) {
            return;
        }
        this.reportAfterEnterTextEditor();
        this.isEditing = true;
        this.makeElementSelected(e, source === 'placeholder');
        this.setModel({
            editorFocus: true,
        }, () => {
            if (browser.isMobile) {
                this.getChildRef('editor')?.setFocus();  // 神坑，iOS下setFocus放在setTimeOut里会不执行，Android暂时不知道影响
            } else {
                setTimeout(() => this.getChildRef('editor')?.setFocus(), 0); // 某些情况下循环渲染场景会造成blur，推迟进行focus
            }
        });
    };

    private reportAfterEnterTextEditor = () => {
        let inGroup = false;
        enumerateGroup(this.component, () => {
            inGroup = true;
            return true;
        });
        if (inGroup) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_OBJ,
                action: TDWActionType.EDIT_SHAP_TEXT,
            });
        } else {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: browser.isMobile ? TDWModuleType.M_SHAPE_EDIT : TDWModuleType.PC_OBJ,
                action: browser.isMobile ? TDWActionType.M_EDIT_EDIT : TDWActionType.EDIT_TEXT,
            });
        }
    };

    private makeElementSelected = (e: any, notReport?: boolean) => {
        (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.selectedAnims?.clear();

        let rootGroup: any = null;
        enumerateGroup(this.component, (groupModel) => {
            rootGroup = groupModel;
        });

        const selectedSlideArr = this.getSelectionService()?.selectedElements.
            selectedArrayForType(SelectedEleMgrType.SLIDE);


        mobx.transaction(() => {
            if (isDecoratorKey(e)) {
                // 选择 slide 的上的文本编辑器 就把组合中选择元素去除
                if (rootGroup === null) {
                    this.addSelectElement();
                } else if (rootGroup.selected) {
                    this.addWithElementSelected(selectedSlideArr, rootGroup);
                } else {
                    this.clearAndAddGroupSelected(rootGroup);
                }
            } else {
                this.setElementSelected(rootGroup, notReport);
            }
        });
    };

    private addSelectElement = () => {
        this.getSelectionService()?.selectedElements.clear(SelectedEleMgrType.GROUP);
        if (this.component.selectable && !this.component.selected) {
            this.getSelectionService()?.selectedElements.add(this.component);
        }
        this.triggerEditorBlur();
    };

    private addWithElementSelected = (selectedSlideArr, rootGroup) => {
        if (selectedSlideArr.length === 1) {
            if (this.component?.selectable && !this.component?.selected) {
                this.getSelectionService()?.selectedElements.add(this.component);
            }
            this.triggerEditorBlur();
        } else {
            this.getSelectionService()?.selectedElements.remove(rootGroup);
            this.triggerEditorBlur();
        }
    };

    private clearAndAddGroupSelected = (rootGroup) => {
        this.getSelectionService()?.selectedElements.clear(SelectedEleMgrType.GROUP);
        // 添加Root Group 逻辑
        const selectedArr = this.getSelectionService()?.selectedElements.
            selectedArrayForType(SelectedEleMgrType.SLIDE);
        if (rootGroup && selectedArr?.indexOf(rootGroup) === -1) {
            this.getSelectionService()?.selectedElements.add(rootGroup);
        }
        this.triggerEditorBlur();
    };

    private triggerEditorBlur = () => {
        setTimeout(() => {
            this.getChildRef('editor')?.triggerBlur();
        });
    };

    private showNotEditTips = (cb?: Function) => {
        if (this.getUserPriviledgeService().pptEditorState > PPTEditorStateType.EDITABLE) {
            (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
                .viewableServiceLayer.tipsManager.showCannotEditTips();
            cb?.();
        }
    };

    private handleElementFocus = () => {
        if (this.component) {
            // 当文本框在编辑状态时，属性值交由文本框处理
            if (this.getChildRef('editor') && !this.getChildRef('editor').isEditing) {
                this.component.selectionStyles = this.getChildRef('editor').getAllStyles();
            }
        }
    };

    private handleElementBlur = () => {
        this.component && (this.component.selectionStyles = null);
        this.handleEditorBlur({ needUpd8: true });
    };

    private handleEditorBlur = ({ needUpd8 = false } = {}) => {
        this.getChildRef('editor')?.triggerBlur({ needUpd8: this.props.editable && needUpd8 });
        this.setModel({
            editorFocus: false,
            mobileEditingTriggerFlag: false,
        });
        this.isEditing = false;
    };

    private setElementSelected = (rootGroup: any, notReport?: boolean) => {
        const lastSelected = this.component?.selected;
        this.getSelectionService()?.selectedElements.clear();
        this.getSelectionService()?.selectedElements.add(this.component);
        // 添加Root Group 逻辑
        const selectedArr = this.getSelectionService()?.selectedElements.selectedArrayForType(SelectedEleMgrType.SLIDE)
            || [];
        if (rootGroup && selectedArr.indexOf(rootGroup) === -1) {
            this.getSelectionService()?.selectedElements.add(rootGroup);
        }

        if (this.component?.selectable && !lastSelected && !notReport) {
            let inGroup = false;
            enumerateGroup(this.component, () => {
                inGroup = true;
                return true;
            });
            if (!inGroup) {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_OBJ,
                    action: TDWActionType.CLK_EDIT,
                });
            }
        }
    };

    private updateElementFocus = () => {
        if (this.component) {
            this.component.editorComponent = this.getChildRef('editor');
            // 此方法本应该在ShapeModel的didConvertDataSdkToUi中调用，但是内部需要从editor取值，所以只能先放在这里了
            this.component.getMenuManager()?.event.emit(ModelMenuRefreshEventsKeys.REFRESH_MENU_ITEM_VALUES);
            this.component.getMenuManager()?.event.emit(ModelMenuRefreshEventsKeys.REFRESH_GROUP_ITEM_VALUES);
        }
        if (this.autoFocus) {
            requestAnimationFrame(() => requestAnimationFrame(this.initFocus));
        }

        this.selectElementChangeReaction = mobx.reaction(
            () => ({
                selectedArray: this.getSelectionService()?.selectedElements.selectedArray,
            })
            , (obj) => {
                // @ts-ignore
                if (this.mounted && obj.selectedArray?.length > 1 && this.component?.selected && this.getChildRef('editor')?.isEditing) {
                    this.getChildRef('editor').triggerBlur({ needUpd8: true });
                }
            },
        );
    };

    /**
     * 选中占位符编辑，因为上层模态失焦后，需要恢复编辑态的事件处理
     * @param e 自定义事件，包含了model的key值
     */
    private handleEnterEmptyPlaceholder = (e) => {
        // 判定key是相同的，再进行响应
        if (e.detail.key === this.component?.key) {
            this.handlePlaceHolderClick(PlaceHolderMode.BLANK, e);
        }
    };

    private getSelectionService(): ISelectionService | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService?.viewableServiceLayer?.selectionService;
    }

    private getTextEditorStateService(): ITextEditorStateService {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService.viewableServiceLayer.textEditorStateService;
    }

    private getUserPriviledgeService(): IUserPriviledgeService {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService.viewableServiceLayer.userPriviledgeService;
    }

    private getEditingStateManager() {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService.viewableServiceLayer.editingStateManager;
    }

    private getSearchReplaceManager() {
        const appService = AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
        return appService.editableServiceLayer?.searchReplaceManager?.dangerousInstance;
    }

    private getUndoRedoService() {
        const appService = AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
        return appService.editableServiceLayer?.undoRedoService;
    }

    private getLinkManager() {
        const appService = AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
        return appService.viewableServiceLayer.linkManager;
    }
}
